export const TOKEN_KEY = 'token';

export default {
  TOKEN_KEY,
};
